import { Component } from '@angular/core';
import { ContentComponent } from '../../components/content/content.component';
import { SpinnerComponent } from '../../common/spinner/spinner.component';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { logout } from '../../store/actions/app.actions';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [
    ContentComponent,
    SpinnerComponent
  ],
  template: '<app-content> <section style="text-align: center"><app-spinner></app-spinner></section> </app-content>',
  styles: ''
})
export class LogoutComponent {
  constructor(
    private store$: Store,
    private router: Router
  ) {
    this.store$.dispatch(
      logout({
        successFnc: () => {
          this.router.navigate(['/strona-glowna']);
        }
      })
    );
  }

}
